import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["prefix", "noTrack"];

/**
 * Subscribe to react-router `history` events and send normalized 'page.display' accordingly.
 * For every `history` event, the current location is matched against the app's routes so we
 * can build the user's path.
 * - history's basename is ignored.
 *   (no sharing_id/locale but app name, if any, is present in the `baseURL` parameter).
 * - URL parameters values are ignored as well, since the route path declaration is used.
 * Examples:
 * - https://admin.beta.gandi.net/simplehosting/instances/:instanceId/sites/:fqdn/ssl-activate
 * - https://admin.beta.gandi.net/domain/:fqdn/dns/:zone/restore/:snapshot/delete
 * - https://shop.beta.gandi.net/domain/suggest(/:cartId)
 */
import { sendPage } from './sendPage';
import { getTrackingProps } from './helpers';
export var connectToHistory = function connectToHistory(_ref) {
  var history = _ref.history,
      match = _ref.match,
      routes = _ref.routes;

  function matchLocation(location) {
    var _location$state;

    if (location !== null && location !== void 0 && (_location$state = location.state) !== null && _location$state !== void 0 && _location$state.noTrack) {
      return undefined;
    }

    return match({
      routes: routes,
      location: location,
      history: history
    }, function (error, redirectLocation, renderProps) {
      if (renderProps) {
        var trackingProps = getTrackingProps(renderProps.routes, renderProps.params);

        if (!trackingProps) {
          return undefined;
        }

        var prefix = trackingProps.prefix,
            noTrack = trackingProps.noTrack,
            trackingPageProps = _objectWithoutProperties(trackingProps, _excluded);

        return sendPage(trackingPageProps);
      }

      return undefined;
    });
  } // Initial page load tracking


  matchLocation(); // Subsequent client-side navigations

  history.listen(matchLocation);
};